export type FeatureFlag = "coach" | "affiliates" | "partnerHub";

export const FEATURE_FLAGS: Record<FeatureFlag, boolean> = {
  coach: false,       // /coach, /projects/:id, idea coach tab, project promote
  affiliates: false,  // /affiliates*, dashboard, apply, admin tab
  partnerHub: false,  // /partner, partner_admin nav
};

export const isFlagOn = (flag: FeatureFlag) => FEATURE_FLAGS[flag];